import Skeleton from "react-loading-skeleton";
import { ArrowUprightCircleIcon } from "../../../../../assets/icons";
import styles from "./consumption-chart-card.module.scss";


export const ConsumptionChartCardSkeleton = () => {
	return (
		<div className={styles.skeletonCard}>
			<div className={styles.inner}>
				<div className={styles.header}>
					<div className={styles.headerLeft}>
						<span className={styles.title}>This Week&apos;s Consumption Trend</span>
						<Skeleton width={90} height={28} />
					</div>
					<button className={styles.analyticsLink} disabled>
						<ArrowUprightCircleIcon width={22} height={22} />
						Full Analytics
					</button>
				</div>
				<Skeleton height={192} borderRadius={8} />
			</div>
		</div>
	);
};
